import axiosInstance from 'utils/axiosInstance';
import {
  ChatData,
  ChatHeader,
  ChatUnreadCount,
  FilterMessage,
  GetChatHeaderType,
  GetUserList,
  GroupDetail,
  Message,
  MessagesByDate,
  UserFilters,
} from '../types/types';

export const chatlistService = async (
  filters: UserFilters,
): Promise<ApiResponse<ChatData>> => {
  const { data } = await axiosInstance.post('/api/chat/chatlist', filters);
  return data;
};

export const groupListService = async (
  filters: UserFilters,
): Promise<ApiResponse<ChatData>> => {
  const { data } = await axiosInstance.post('/api/chat/GroupList', filters);
  return data;
};

export const GetMessagesService = async (
  filters: FilterMessage,
): Promise<MessagesByDate[]> => {
  const { data } = await axiosInstance.post('/api/chat/GetMessages', filters);
  return data.data;
};

export const SendMessageService = async (
  values: FormData,
): Promise<ApiResponse<Message>> => {
  const { data } = await axiosInstance.post('/api/chat/SendMessage', values);
  return data;
};

export const DeleteChatMessageService = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete(
    `/api/chat/DeleteChatMessage/${id}`,
  );
  return data;
};

export const GetChatHeader = async (
  ChatHeaderType: GetChatHeaderType,
): Promise<ApiResponse<ChatHeader>> => {
  const { data } = await axiosInstance.post(
    'api/chat/ChatHeader',
    ChatHeaderType,
  );
  return data;
};

export const GetUserslist = async (
  values: GetUserList,
): Promise<SelectItem[]> => {
  const { data } = await axiosInstance.post('/api/chat/userslist', values);
  return data.data;
};

export const CreatGroupeServices = async (
  values: FormData,
): Promise<ApiResponse<SelectItem>> => {
  const { data } = await axiosInstance.post('/api/chat/CreatGroupe', values);
  return data;
};

export const UpdateGroupeServices = async (
  values: FormData,
): Promise<ApiResponse<SelectItem>> => {
  const { data } = await axiosInstance.post('/api/chat/UpdateGroup', values);
  return data;
};

export const GetGroupDetailsByIdServices = async (
  id: number,
): Promise<ApiResponse<GroupDetail>> => {
  const { data } = await axiosInstance.get(`/api/chat/GetGroupDetails/${id}`);
  return data;
};

export const deleteGroupServices = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.delete(`/api/chat/DeleteGroup/${id}`);
  return data;
};

export const GetChatUnreadCount = async (): Promise<
  ApiResponse<ChatUnreadCount>
> => {
  const { data } = await axiosInstance.get('/api/chat/UnreadCount');
  return data;
};

export const MarkChatAsSeen = async (
  id: string,
  isgroup: boolean,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post('/api/chat/Seen', { id, isgroup });
  return data;
};
